import * as Yup from 'yup';
import YupPassword from 'yup-password';

import { getFormValidator } from '@util/form/get-form-validator';

YupPassword(Yup);

export const registrationFormValidation = getFormValidator(
  Yup.object().shape({
    email: Yup.string().required('Must be a valid email address').email('Must be a valid email address'),
    password: Yup.string()
      .min(
        12,
        'Password must contain 12 or more characters with at least one of each: uppercase, lowercase, number and special',
      )
      .minLowercase(1, 'Password must contain at least 1 lower case letter')
      .minUppercase(1, 'Password must contain at least 1 upper case letter')
      .minNumbers(1, 'Password must contain at least 1 number')
      .minSymbols(1, 'Password must contain at least 1 special character'),
    profile: Yup.object().shape({
      name: Yup.string().required('First name is required'),
      lastname: Yup.string().required('Last name is required'),
      company: Yup.string().test('Company website', 'Must be a valid website address', (value) => {
        if (!value) {
          return true;
        }

        const urlToValidate = value.startsWith('http') ? value : `https://${value}`;

        return Yup.string().url().isValidSync(urlToValidate);
      }),
    }),
  }),
);
